var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('balanceCard'),_c('br'),_c('tariffCard')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('h1',{staticClass:"page__title"},[_vm._v("Пополнить баланс")])])
}]

export { render, staticRenderFns }